module.exports = __webpack_public_path__ + "img/sir-john-herschel.1cf62c38.png";